<template>
  <div class="row mt-4">
    <div class="col-12">
      <material-input id="title" v-model="titleHandler" is-required variant="static" label="Titel"
        placeholder="Vul een titel in" />
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <material-input id="subtitle" v-model="subtitleHandler" variant="static" label="Subtitel"
        placeholder="Vul een subtitel in" />
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <dropdown button-padding-class="ps-4" label="Parent" :options="parentOptions" :show-images="false"
        :value="parentIdHandler" @update:value="(v) => parentIdHandler = v" />
    </div>
  </div>

  <material-button v-if="showUpdate" class="float-end mt-6 mb-0" color="dark" variant="gradient" size="sm">
    Update gegevens
  </material-button>
</template>

<script>
import { createVModelHandlers } from '@/helpers/vue';
import Dropdown from '@/components/UI/Dropdown.vue';
import MaterialButton from '@/components/MaterialButton.vue';
import MaterialInput from '@/components/MaterialInput.vue';

export default {
  name: 'BasicInfo',

  components: {
    Dropdown,
    MaterialButton,
    MaterialInput,
  },

  props: {
    subtitle: {
      type: String,
      required: true,
    },
    showUpdate: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    parentId: {
      type: [Number, null],
      required: true,
      default: null,
    },
    availableParents: {
      type: [Array, null],
      default: () => []
    }
  },

  emits: [
    'update:description',
    'update:parentId',
    'update:subtitle',
    'update:title'
  ],

  computed: {
    ...createVModelHandlers(
      'description',
      'parentId',
      'subtitle',
      'title'
    ),
    parentOptions() {
      try {
        return [
          {
            value: null,
            label: 'Geen',
          },
          ...((this.availableParents ?? []).map((parent) => ({
            value: parent.id,
            label: parent.title,
          }))),
        ];
      } catch {
        return [];
      }

    }
  },
};
</script>